import { Injectable } from '@angular/core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { inject } from '@angular/core';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../../environments/environment';
import { NewRepApplication } from '../../new-rep-application-models/new-rep-application.model';
import { MnchecklistModel } from '../../new-rep-application-models/mnchecklist-models/mnchecklist-model';


@Injectable({
  providedIn: 'root'
})
export class MnchecklistService {
  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

   async getmnchecklist(repCode:string) {

    const API_URL: string = environment.baseUrl + environment.apis.getmnchecklist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "pias_rep_code": repCode,
        "updated_by_role":["Director","NEWREP","Manager","DSU", "DSU Manager"]
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async postmnchecklist(mnchecklist:MnchecklistModel) {

    const API_URL: string = environment.baseUrl + environment.apis.postmnchecklist;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data:mnchecklist.toString()
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  
}
